import _ from 'lodash'

export default ceil

function ceil() {
    return function (val) {
        return _.isNumber(val) ? Math.ceil(val) : val
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/ceil.js